import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'
import * as GuiaVentaService from 'services/guiasVenta.service'

import * as InventarioService from 'services/inventario.service'
import { DownloadAxiosFile } from 'utils'

const portletBreadcrumbs = [{ name: 'Guias Ventas' }]

const tableHeaderRows = [
  { label: 'FECHA', width: 100, align: 'center' },
  { label: 'TIPO', width: 190, align: 'center' },
  {
    label: 'SERIE DOC',
    width: 120,
    align: 'center',
    filter: {
      type: 'text',
      name: 'serDoc'
    }
  },
  {
    label: 'NUM. DOC',
    width: 130,
    align: 'center',
    filter: {
      type: 'text',
      name: 'numDoc'
    }
  },
  { label: 'RUC', width: 130, align: 'center' },
  { label: 'RAZÓN SOCIAL', align: 'center' },
  { label: '', width: 30, align: 'center' }
]

const ListaComprasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickNuevoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.VENTASINGRESOGUIA_NUEVA}`)
  }

  const clickEditarHandler = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.VENTASINGRESOGUIA_NUEVA}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      InventarioService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickDescargarPdf = React.useCallback(({ _id }) => {
    GuiaVentaService.descargarPdfGuia(_id).then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers)
    })
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Guias Ventas' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevoHandler }]} />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            useFilters={true}
            url='/kardex'
            baseParams={{
              tipoConsulta: 'guias-ventas'
            }}
            headRows={tableHeaderRows}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
                </Table.Cell>
                <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.documentoSocio || '--'}</Table.Cell>
                <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={() => clickEditarHandler({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={() => clickEliminar({ _id: row._id })}>
                        Eliminar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='descargar' handleClose={handleClose} onClick={() => clickDescargarPdf({ _id: row._id })}>
                        Imprimir
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ListaComprasPage
